import React, { useEffect, useState } from "react";
import { Container, Row, Col, Label, FormGroup, Input } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { getFundByAmc } from "../../stores/services/funds.service";
import { useSelector } from "react-redux";
import Select from "react-select";
import ReactTooltip from "react-tooltip";
import {
  calculateDividendDisbursement,
  getAllActiveUnpaidDividendAnnouncementsByFund,
  getAllDividendAnnouncements,
  getCorporateAnnouncementByID,
} from "../../stores/services/dividend-announcement.service";
import moment from "moment";
import { BsTable } from "react-icons/bs";
import {
  generateDividendLedgerEntries,
  numberWithCommas,
} from "../../utils/customFunction";
import { getLedgerInfoByCode } from "../../stores/services/chatofaccounts.service";
import TableHeading from "../../components/ui/TableHeading";
import { processDisbursementHeadings } from "../../utils/ui_data";
import DividendTable from "./DividendTable";
import { useCustomStylesDropDown } from "../../assets/css/customStyle";

function ProcessDividendDisbursementModal() {
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const { customStyles } = useCustomStylesDropDown();
  const email = sessionStorage.getItem("email") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const [fundDataLoading, setFundDataLoading] = useState(false);
  const [announcementDataLoading, setAnnouncementDataLoading] = useState(false);
  const [dividendDataLoading, setDividendDataLoading] = useState(false);
  const [ledgerTableDataLoading, setLedgerTableDataLoading] = useState(false);

  const [fundData, setFundData] = useState<any>([]);
  const [announcementData, setAnnouncementData] = useState<any>([]);
  const [dividendData, setDividendData] = useState<any>([]);
  const [ledgerTableData, setLedgerTableData] = useState<any>([]);

  const [selectedFund, setSelectedFund] = useState("");
  const [selectedAnnoucement, setSelectedAnnoucement] = useState("");
  let totalDebitAmount = 0;
  let totalCreditAmount = 0;

  useEffect(() => {
    setFundDataLoading(true);
    const getFundByAMcCode = async (code: string) => {
      setFundData([]);

      try {
        const response = await getFundByAmc(
          email,
          code,
          fund_code?.length > 0 ? fund_code : ""
        );
        // sort data
        let sortedData: any = [];
        sortedData = response.data.data.sort(function (a, b) {
          let x = a.nature.toLowerCase();
          let y = b.nature.toLowerCase();
          if (x > y) {
            return 1;
          }
          if (x < y) {
            return -1;
          }
          return 0;
        });
        if (sortedData.length === 1) {
          setSelectedFund(sortedData[0].fund_code);
        }
        // setAllFunds(response.data.data);
        setFundData(sortedData);
        setFundDataLoading(false);
      } catch (error) { }
    };

    getFundByAMcCode(amc_code);
  }, []);

  const getAnnoucement = async (fundVal) => {
    try {
      setAnnouncementDataLoading(true);
      let res = await getAllDividendAnnouncements(email, amc_code, fundVal);
      if (res.data.status === 200 && res?.data?.data?.length > 0) {
        setAnnouncementData(res.data.data);
        setAnnouncementDataLoading(false);
      } else {
        // toast.error("No Record Found for Annoucement!")
        setAnnouncementData([]);
        setAnnouncementDataLoading(false);
      }
    } catch (error) {
      setAnnouncementData([]);
      setAnnouncementDataLoading(false);
    }
  };

  const getLedgerInfo = async (email, ledger_code, fund_code) => {
    const result = await getLedgerInfoByCode(email, ledger_code, fund_code);
    return result.data.data;
  };

  const handleSearch = async () => {
    setDividendDataLoading(true);
    setLedgerTableDataLoading(true);
    setDividendData([]);
    try {
      let announcementDetails = announcementData.find(
        (item) => item.announcement_id === selectedAnnoucement
      );
      let res = await calculateDividendDisbursement(
        email,
        amc_code,
        selectedFund,
        announcementDetails.announcement_id,
        announcementDetails.announcement_number,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      );
      if (res.data.status === 200 && res.data.data?.length > 0) {
        const responseUndistributedProfitLossLedger = await getLedgerInfo(
          email,
          201050101,
          selectedFund
        );
        const responseDividendDistributionPayableLedger = await getLedgerInfo(
          email,
          301030201,
          selectedFund
        );
        const responseSaleUnitLedger = await getLedgerInfo(
          email,
          201010101,
          selectedFund
        );
        const responseWHTLedger = await getLedgerInfo(
          email,
          301030502,
          selectedFund
        );
        const ledgerEntries = generateDividendLedgerEntries({
          amc_code,
          fund_code: selectedFund,
          grossDividend: parseFloat(res.data.totalGrossDividend || "0"),
          netDividend: parseFloat(res.data.totalNetDividend || "0"),
          refundCapital: parseFloat(res.data.totalRefundCapital || "0"),
          taxAmount: parseFloat(res.data.totalTaxAmount || "0"),
          undistributedLedger: responseUndistributedProfitLossLedger,
          payableLedger: responseDividendDistributionPayableLedger,
          saleUnitLedger: responseSaleUnitLedger,
          whtLedger: responseWHTLedger,
        });

        setLedgerTableData(ledgerEntries);
        setDividendData(res?.data?.data);
        setLedgerTableDataLoading(false);
        setDividendDataLoading(false);
      } else {
        setLedgerTableData([]);
        setDividendData([]);
        toast.error(res?.data?.message || res?.message);
        setLedgerTableDataLoading(false);

        setDividendDataLoading(false);
      }
    } catch (error) {
      setLedgerTableData([]);
      setDividendData([]);
      setLedgerTableDataLoading(false);

      setDividendDataLoading(false);
      toast.error("No data found!");
    }
  };

  const renderFundsDropdown = () => {
    return fundData.map((item: any, index: string) => {
      if (item.nature === "Special Managed Account") {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code}) - SMA`,
        };
      } else {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code})`,
        };
      }
    });
  };

  const renderAnnoucementDropdown = () => {
    return announcementData?.map((item: any, index: string) => {
      return {
        value: item?.announcement_id,
        label: `${moment(item?.to_date)?.format("DD-MMM-YYYY")} - ${item?.description?.length > 30
          ? item?.description?.slice(0, 30) + "..."
          : item?.description
          }`,
      };
    });
  };

  const selectedFundName = React.useMemo(() => {
    const selectFund = fundData.find(
      (item) => item.symbol_code === selectedFund
    );

    return selectFund && selectFund.nature === "Special Managed Account"
      ? {
        value: selectFund.symbol_code,
        label: `${selectFund.fund_name} (${selectFund.symbol_code}) - SMA`,
      }
      : selectFund
        ? {
          value: selectFund.symbol_code,
          label: `${selectFund.fund_name} (${selectFund.symbol_code})`,
        }
        : null;
  }, [fundData, selectedFund]);

  const selectedAnnouncementVal = React.useMemo(() => {
    const selected = announcementData.find(
      (item) => item?.announcement_id === selectedAnnoucement
    );
    return selected
      ? {
        value: selected?.announcement_id,
        label: `${moment(selected?.to_date)?.format("DD-MMM-YYYY")} - ${selected?.description
          }`,
      }
      : null;
  }, [announcementData, selectedAnnoucement]);

  return (
    <Col className="px-0">
      <Row>
        <Col>
          <div className="card mb-3">
            <div className="card-header">
              <h4 className="card-title">Process Disbursement</h4>
            </div>
            <div className="card-body">
              <Row className="align-items-center">
                <Col
                  md={4}
                  sm={12}
                  xs={12}
                  className="form-group col-md-4"
                  data-tip="Select Fund"
                >
                  Fund Name*
                  <ReactTooltip
                    textColor="white"
                    backgroundColor="black"
                    effect="float"
                  />
                  {fundDataLoading ? (
                    <div className="form-control w-100">
                      <i className="fa fa-spinner fa-spin fa-1x"></i>
                    </div>
                  ) : (
                    <Select
                      disabled={false}
                      value={selectedFundName}
                      label={selectedFund ? "No Fund Found" : "Select Fund"}
                      onChange={(e) => {
                        setLedgerTableData([]);
                        setAnnouncementData([]);
                        setDividendData([]);
                        getAnnoucement(e?.value);
                        setSelectedFund(e?.value);
                      }}
                      menuPortalTarget={document.body}
                      menuShouldBlockScroll={true}
                      isClearable={true}
                      isSearchable={true}
                      name="color"
                      options={renderFundsDropdown()}
                      styles={customStyles}
                    />
                  )}
                </Col>
                <Col
                  md={4}
                  sm={12}
                  xs={12}
                  className="form-group col-md-4"
                  data-tip="Select Announcement"
                >
                  Announcement*
                  <ReactTooltip
                    textColor="white"
                    backgroundColor="black"
                    effect="float"
                  />
                  {announcementDataLoading ? (
                    <div className="form-control w-100">
                      <i className="fa fa-spinner fa-spin fa-1x"></i>
                    </div>
                  ) : (
                    <Select
                      isDisabled={!selectedFund}
                      value={selectedAnnouncementVal}
                      label={
                        selectedFund
                          ? "No Announcement Found"
                          : "Select Announcement"
                      }
                      onChange={(e) => {
                        setLedgerTableData([]);
                        setDividendData([]);

                        setSelectedAnnoucement(e?.value);
                      }}
                      menuPortalTarget={document.body}
                      menuShouldBlockScroll={true}
                      isClearable={true}
                      isSearchable={true}
                      name="color"
                      options={renderAnnoucementDropdown()}
                      styles={customStyles}
                    />
                  )}
                </Col>
                <Col md={4} sm={12} xs={12}>
                  <button
                    style={{
                      marginTop: "25px",
                    }}
                    className="btn btn-primary"
                    disabled={
                      fundDataLoading ||
                      announcementDataLoading ||
                      !selectedFund ||
                      !selectedAnnoucement ||
                      dividendDataLoading
                    }
                    onClick={() => {
                      handleSearch();
                    }}
                  >
                    {dividendDataLoading ? (
                      <>
                        <span
                          className="spinner-border login-txt spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span className="login-txt"> Calculating...</span>
                      </>
                    ) : (
                      "Calculate"
                    )}
                  </button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <DividendTable dividendData={dividendData} />
                  <div className="table-responsive">
                    {ledgerTableData && ledgerTableData.length > 0 && (
                      <Row>
                        <Col>
                          <div className="card">
                            <div className="card-header">
                              <h4 className="card-title text-primary">
                                Affected Ledgers
                              </h4>
                            </div>
                            <div className="card-body">
                              <div className="table-responsive">
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th>Code</th>
                                      <th>Name</th>
                                      <th className="text-center">
                                        Debit Amount
                                      </th>
                                      <th className="text-center">
                                        Credit Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {ledgerTableData.map((data, index) => {
                                      totalDebitAmount +=
                                        +data?.debit_amount || 0;
                                      totalCreditAmount +=
                                        +data?.credit_amount || 0;
                                      return (
                                        <tr
                                          key={index}
                                          style={{
                                            background:
                                              theme === "light"
                                                ? ""
                                                : "rgba(37,41,61,1)",
                                          }}
                                        >
                                          <td>{data.gl_code}</td>
                                          <td>{data.gl_name}</td>
                                          <td className="text-center">
                                            {numberWithCommas(
                                              Number(
                                                data.debit_amount || 0
                                              ).toFixed(4)
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {numberWithCommas(
                                              Number(
                                                data.credit_amount || 0
                                              ).toFixed(4)
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                  <tbody>
                                    <tr>
                                      <td>Total</td>
                                      <td></td>
                                      <td className="text-center">
                                        {numberWithCommas(
                                          Number(totalDebitAmount || 0).toFixed(
                                            4
                                          )
                                        )}
                                      </td>
                                      <td className="text-center">
                                        {numberWithCommas(
                                          Number(
                                            totalCreditAmount || 0
                                          ).toFixed(4)
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );
}

export default ProcessDividendDisbursementModal;
